export interface AuraFilters {
    dateFrom?: string;
    dateTo?: string;
    operatorId?: number;
    queueId?: number;
    mediaId?: string;
    verticalId?: number;
}

export function sanitizeAuraHeaderFilters(
    filters: AuraFilters | null | undefined,
): AuraFilters | null {
    if (!filters) return null;

    const sanitized: AuraFilters = {};
    if (filters.dateFrom) sanitized.dateFrom = filters.dateFrom;
    if (filters.dateTo) sanitized.dateTo = filters.dateTo;
    if (filters.operatorId !== undefined) sanitized.operatorId = filters.operatorId;
    if (filters.queueId !== undefined) sanitized.queueId = filters.queueId;
    if (filters.mediaId) sanitized.mediaId = filters.mediaId;

    return Object.keys(sanitized).length ? sanitized : null;
}
